export default [
  {
    path: '/home',
    component: resolve => require(['@/views/home/Home.vue'], resolve),
    meta: {
      pageId: 'home'
    }
  },
  {
    path: '/ai',
    component: resolve => require(['@/views/home/ai/index.vue'], resolve),
    meta: {
      pageId: 'ai'
    }
  },
  {
    path: '/ai-designer',
    component: resolve => require(['@/views/home/ai/Ai.vue'], resolve),
    meta: {
      pageId: 'ai_designer'
    }
  },
  {
    path: '/40seas',
    component: resolve => require(['@/views/home/40seas/index.vue'], resolve),
    meta: {
      pageId: '40seas'
    }
  },
  // {
  //   path: '/product',
  //   component: resolve => require(['@/views/home/Product.vue'], resolve)
  // },
  {
    path: '/dropshipping',
    // component: resolve => require(['@/views/home/Dropshipping.vue'], resolve),
    component: resolve => require(['@/views/home/dropshipping/index.vue'], resolve),
    meta: {
      pageId: 'home_dropshipping'
    }
  },
  {
    path: '/service',
    // component: resolve => require(['@/views/home/Customization.vue'], resolve)
    // component: resolve => require(['@/views/home/CustomizationNew.vue'], resolve),
    component: resolve => require(['@/views/home/customized/customizeView.vue'], resolve),
    meta: {
      pageId: 'home_service'
    }
  },
  // {
  //   path: '/blog',
  //   component: resolve => require(['@/views/home/blogContent/Blog.vue'], resolve),
  //   meta: {
  //     pageId: 'home_blog'
  //   }
  // },
  // {
  //   path: '/blog/:id?',
  //   component: resolve => require(['@/views/home/blogContent/Detail.vue'], resolve),
  //   meta: {
  //     pageId: 'home_blogDetail'
  //   }
  // },
  {
    path: '/about-us',
    component: resolve => require(['@/views/home/About.vue'], resolve),
    meta: {
      pageId: 'home_aboutCompany'
    }
  },
  {
    path: '/login',
    name: '/login',
    // component: resolve => require(['@/views/home/Login.vue'], resolve),
    component: resolve => require(['@/views/home/login/login.vue'], resolve),
    meta: {
      pageId: 'home_login'
    }
  },
  {
    path: '/register',
    name: '/register',
    // component: resolve => require(['@/views/home/Register.vue'], resolve),
    component: resolve => require(['@/views/home/login/register.vue'], resolve),
    meta: {
      pageId: 'home_register'
    }
  },
  {
    path: '/return-refund',
    component: resolve => require(['@/views/home/terms/RefundInformation.vue'], resolve),
    meta: {
      pageId: 'home_refundRules'
    }
  },
  {
    path: '/privacy-policy',
    component: resolve => require(['@/views/home/terms/PrivacyPolicy.vue'], resolve),
    meta: {
      pageId: 'home_privacyPolicy'
    }
  },
  {
    path: '/terms-conditions',
    component: resolve => require(['@/views/home/terms/TermsConditions.vue'], resolve),
    meta: {
      pageId: 'home_termsConditions'
    }
  },
  {
    path: '/shipping',
    component: resolve => require(['@/views/home/terms/ShippingDelivery.vue'], resolve),
    meta: {
      pageId: 'hoem_shippingDelivery'
    }
  },
  {
    path: '/payment-method',
    component: resolve => require(['@/views/home/terms/PaymentMethod.vue'], resolve),
    meta: {
      pageId: 'home_paymentMethod'
    }
  },
  {
    path: '/help-center',
    component: resolve => require(['@/views/home/helpCenter/Index.vue'], resolve),
    children: [
      {
        path: '/help-center',
        component: resolve => require(['@/views/home/helpCenter/Tutorial.vue'], resolve),
        meta: {
          pageId: 'home_helpCenter'
        }
      },
      {
        path: '/faq/:name?',
        component: resolve => require(['@/views/home/helpCenter/FAQ.vue'], resolve),
        meta: {
          pageId: 'home_faq'
        }
      },
      {
        path: '/help-center/search-center',
        component: resolve => require(['@/views/home/helpCenter/SearchCenter.vue'], resolve),
        meta: {
          pageId: 'home_searchCenter'
        }
      },
      {
        path: '/tutorial-content',
        component: resolve => require(['@/views/home/helpCenter/TutorialDetail.vue'], resolve),
        meta: {
          pageId: 'home_tutorialContent'
        }
      },
      {
        path: '/tutorial-content/:id?',
        component: resolve => require(['@/views/home/helpCenter/MobileTutorialList.vue'], resolve),
        meta: {
          pageId: 'home_tutorialContent'
        }
      },
      {
        path: '/tutorial-detail',
        component: resolve => require(['@/views/home/helpCenter/MobileTutorialDetail.vue'], resolve),
        meta: {
          pageId: 'home_tutorialDetail'
        }
      }
    ]
  },
  {
    path: '/customizedAdd',
    component: resolve => require(['@/views/home/customized/addProduct.vue'], resolve),
    meta: {
      pageId: 'home_customizedAdd'
    }
  },
  {
    path: '/customizedSuccess',
    component: resolve => require(['@/views/home/customized/success.vue'], resolve),
    meta: {
      pageId: 'home_customizedState'
    }
  },
  {
    path: '/contact-us',
    component: resolve => require(['@/views/home/terms/ContactUs.vue'], resolve),
    meta: {
      pageId: 'home_contactUs'
    }
  },
  // {
  //   path: '/aboutus',
  //   component: resolve => require(['@/views/home/terms/AboutUs.vue'], resolve),
  //   meta: {
  //     pageId: 'home_aboutUs'
  //   }
  // },
  // {
  //   path: '/ip-right',
  //   component: resolve => require(['@/views/home/terms/IPRight.vue'], resolve)
  // },
  {
    path: '/certificate',
    component: resolve => require(['@/views/home/certification/AddCertification.vue'], resolve),
    meta: {
      pageId: 'hoem_certificate'
    }
  },
  {
    path: '/certificate-submiited',
    component: resolve => require(['@/views/home/certification/SubmiitedCertification.vue'], resolve),
    meta: {
      pageId: 'home_certificateState'
    }
  },
  {
    path: '/pod',
    component: resolve => require(['@/views/home/pod/index.vue'], resolve),
    meta: {
      pageId: 'home_pod'
    }
  },
  {
    path: '/pod',
    component: resolve => require(['@/views/home/pod/index.vue'], resolve),
    meta: {
      pageId: 'home_pod'
    }
  },
  {
    path: '/pod-designer',
    component: resolve => require(['@/views/home/pod/podDesigner/index'], resolve),
    meta: {
      pageId: 'home_podDesigner'
    }
  }
]

